const ASSET_CONSUMING = {
  "REORDER_ASSETS_CONSUMING_PROD_ASSETS": "REORDER_ASSETS_CONSUMING_PROD_ASSETS",
  "GET_USER_YEAR_TO_DATE_AVOIDED_CO2_SUCCESS": "GET_USER_YEAR_TO_DATE_AVOIDED_CO2_SUCCESS",
  "GET_CONSUMING_ASSET_YEAR_TO_DATE_AVOIDED_CO2_SUCCESS": "GET_CONSUMING_ASSET_YEAR_TO_DATE_AVOIDED_CO2_SUCCESS",
  "GET_OFFICIAL_DATA_FOR_CONSUMING_ASSET": "GET_OFFICIAL_DATA_FOR_CONSUMING_ASSET",
  "GET_FRONT_END_DATA_FOR_CONSUMING_ASSET": "GET_FRONT_END_DATA_FOR_CONSUMING_ASSET",
  "GET_PRODUCING_ASSET_PERCENTAGE_FOR_RANGE_SUCCESS": "GET_PRODUCING_ASSET_PERCENTAGE_FOR_RANGE_SUCCESS",
  "GET_PRODUCING_ASSET_PERCENTAGE_YTD_SUCCESS": "GET_PRODUCING_ASSET_PERCENTAGE_YTD_SUCCESS",
  "GET_PRODUCING_ASSET_PERCENTAGE_LAST_MATCHED_DAY_SUCCESS": "GET_PRODUCING_ASSET_PERCENTAGE_LAST_MATCHED_DAY_SUCCESS",
  "COMPUTE_AVERAGE_DISTANCE_FOR_RANGE_SUCCESS": "COMPUTE_AVERAGE_DISTANCE_FOR_RANGE_SUCCESS",
  "COMPUTE_AVERAGE_DISTANCE_YTD_SUCCESS": "COMPUTE_AVERAGE_DISTANCE_YTD_SUCCESS",
  "STOP_LOADING": "ASSET_CONSUMING_STOP_LOADING",
  "START_LOADING": "ASSET_CONSUMING_START_LOADING",
  "RESET_CARD_UNDERLYING_VALUES": "ASSET_CONSUMING_RESET_CARD_UNDERLYING_VALUES",
  "RESET_GRAPH_DATA": "ASSET_CONSUMING_RESET_GRAPH_DATA",
  "RESET_DOUGHNUT_DATA": "ASSET_CONSUMING_RESET_DOUGHNUT_DATA",
  "CUSTOM_BUTTON_PRESSED": "CUSTOM_BUTTON_PRESSED",
  "THIRTY_DAYS_BUTTON_PRESSED": "THIRTY_DAYS_BUTTON_PRESSED",
  "ONE_YEAR_BUTTON_PRESSED": "ONE_YEAR_BUTTON_PRESSED",
  "TWELVE_MONTHS_BUTTON_PRESSED": "TWELVE_MONTHS_BUTTON_PRESSED"
}

const DASHBOARD = {
  "START_LOADING": "DASHBOARD_START_LOADING",
  "SET_LAST_DASHBOARD_LOAD": "SET_LAST_DASHBOARD_LOAD",
  "RESET_LAST_DASHBOARD_LOAD": "RESET_LAST_DASHBOARD_LOAD",
  "STOP_LOADING": "DASHBOARD_STOP_LOADING",
  "GET_FRONT_END_DATA_FOR_USER": "DASHBOARD_GET_FRONT_END_DATA_FOR_USER",
  "GET_PRODUCING_ASSET_PERCENTAGE_FOR_RANGE_SUCCESS": "DASHBOARD_GET_PRODUCING_ASSET_PERCENTAGE_FOR_RANGE_SUCCESS",
  "GET_PRODUCING_ASSET_PERCENTAGE_YTD_SUCCESS": "DASHBOARD_GET_PRODUCING_ASSET_PERCENTAGE_YTD_SUCCESS",
  "GET_PRODUCING_ASSET_PERCENTAGE_LAST_MATCHED_DAY_SUCCESS": "DASHBOARD_GET_PRODUCING_ASSET_PERCENTAGE_LAST_MATCHED_DAY_SUCCESS",
  "GET_ASSETS_CONSUMING_SUCCESS": "DASHBOARD_GET_ASSETS_CONSUMING_SUCCESS",
  "SET_ACTIVE_USER_CONSUMING_ASSETS": "DASHBOARD__SET_ACTIVE_USER_CONSUMING_ASSETS",
  "START": "DASHBOARD_ACTION_TYPE__DASHBOARD_START",
  "SUCCESS": "DASHBOARD_ACTION_TYPE__DASHBOARD_SUCCESS",
  "GET_ASSETS_CONSUMING_FAIL": "DASHBOARD_ACTION_TYPE__GET_ASSETS_CONSUMING_FAIL",
  "SORT_ASSETS_CONSUMING": "DASHBOARD_ACTION_TYPE__SORT_ASSETS_CONSUMING",
  "CHANGE_PAGE": "DASHBOARD_ACTION_TYPE__CHANGE_PAGE",
  "CHANGE_ROWS_PER_PAGE": "DASHBOARD_ACTION_TYPE__CHANGE_ROWS_PER_PAGE",
  "LOGOUT_SUCCESS": "DASHBOARD_ACTION_TYPE__LOGOUT_SUCCESS",
  "TOGGLE_CO2_DETAILS": "DASHBOARD_ACTION_TYPE__TOGGLE_CO2_DETAILS",
  "SET_MATCHING_FREQUENCY": "SET_MATCHING_FREQUENCY",
  "ENABLE_COUNTRY_NAVIGATION": "ENABLE_COUNTRY_NAVIGATION",
  "GLOBAL_VIEW_BUTTON_CLICKED": "GLOBAL_VIEW_BUTTON_CLICKED",
  "COUNTRY_VIEW_BUTTON_CLICKED": "COUNTRY_VIEW_BUTTON_CLICKED"
}

const MESSAGE_DIALOG = {
  "OPEN_ERROR": "OPEN_ERROR",
  "OPEN_SUCCESS": "OPEN_SUCCESS",
  "OPEN_GENERIC_ERROR": "OPEN_GENERIC_ERROR"
}

const LOGS = {
  "CHANGE_PAGE": "LOGS_CHANGE_PAGE",
  "CHANGE_ROWS_PER_PAGE": "LOGS_CHANGE_ROWS_PER_PAGE"
}

const ORGANIZATION = {
  "AUTOMATIC_MATCHING_LIVE_ENABLED_CHANGED": "ORGANIZATION__AUTOMATIC_MATCHING_LIVE_ENABLED_CHANGED",
  "AUTOMATIC_MATCHING_OFFICIAL_ENABLED_CHANGED": "ORGANIZATION__AUTOMATIC_MATCHING_OFFICIAL_ENABLED_CHANGED",
}

const ASSET_PRODUCING = {
  "THIRTY_DAYS_BUTTON_PRESSED": "THIRTY_DAYS_BUTTON_PRESSED",
  "CUSTOM_BUTTON_PRESSED": "CUSTOM_BUTTON_PRESSED",
  "TOGGLE_START_DATE_DIALOG": "TOGGLE_START_DATE_DIALOG",
  "TOGGLE_END_DATE_DIALOG": "TOGGLE_END_DATE_DIALOG",
  "SET_START_DATE": "SET_START_DATE",
  "SET_END_DATE": "SET_END_DATE",
  "DISPLAY_DATE_FILTER": "DISPLAY_DATE_FILTER",
  "HIDE_DATE_FILTER": "HIDE_DATE_FILTER"
}

export const ACTION_TYPE = {
  ASSET_CONSUMING,
  MESSAGE_DIALOG,
  DASHBOARD,
  LOGS,
  ORGANIZATION,
  ASSET_PRODUCING
}


// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js